import React, { useContext as useContextCore } from 'react'

const context = React.createContext(null)
export const CoreProvider = context.Provider

export const useContext = () => useContextCore(context)
